import {Base} from "@/api/Base"

export class RoleListAll extends Base {
    path = "role/listAll"
}